class CreateInvoiceFromCommissionController {
    constructor(commissionToUse, $http, $uibModalInstance, InvoiceTemplate) {
        this.api = $http;
        this.commissionToUse = commissionToUse;
        this.modalInstance = $uibModalInstance;
        this.invoiceTemplateModel = InvoiceTemplate;

        console.log(this.commissionToUse);

        this.invoiceTemplates = [];
        this.dataToSend = {
            extended: {
                invoice_date: new Date(),
                address: this.commissionToUse.address,
                processing_costs_general: this.commissionToUse.processing_costs_general,
                processing_costs_per_person: this.commissionToUse.processing_costs_per_person,
                tax_rate: this.commissionToUse.tax_rate
            },
            positions: {}
        };

        _.each(this.commissionToUse.positions.data, (position) => {
            this.dataToSend.positions[position.id] = {
                amount: position.amount,
                price_per_unit: position.price_per_unit
            }
        });
        this.submitting = false;

        this.loadInvoiceTemplates();
    }

    submit() {
        this.submitting = true;
        this.api.post('billing/invoices/' + this.commissionToUse.id + '/commission-to-invoice', this.dataToSend).then((response) => {
            this.close({
                status: 'success',
                invoice: response.data.data
            })
        }, () => {
            this.close({
                status: 'error'
            })
        });
    }

    loadInvoiceTemplates() {
        this.invoiceTemplates = [];
        this.invoiceTemplateModel.getList().then((collection) => {
            _.forEach(collection, (v, k) => {
                if (v['enable_for_invoice']) {
                    this.invoiceTemplates.push(v.plain());
                }
            });

            this.dataToSend.invoice_template_id = this.invoiceTemplates[0].id;
        });
    }

    close(data) {
        this.modalInstance.close(data);
    }

    cancel() {
        this.modalInstance.dismiss();
    }
}

CreateInvoiceFromCommissionController.$inject = [
    'commissionToUse',
    '$http',
    '$uibModalInstance',
    'InvoiceTemplate',
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:CreateInvoiceFromCommissionController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('CreateInvoiceFromCommissionController', CreateInvoiceFromCommissionController);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/modals/create-invoice-from-commission-controller.js